import type { PlainObjectEditorFormProps } from '../../form/PlainObjectEditorForm/PlainObjectEditorForm';

import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import { usePagePreferences } from '../../hooks/UIPersonalization/usePagePreferences';

import PlainObjectEditorForm from '../../form/PlainObjectEditorForm/PlainObjectEditorForm';
import Panel from '../Panel/Panel';

interface PlainObjectEditorProps extends PlainObjectEditorFormProps {
  additionalClasses?: string;
  testId?: string;
}

const PlainObjectEditor = ({
  additionalClasses,
  testId,
  ...props
}: PlainObjectEditorProps) => {
  const { t } = useTranslation();

  const isInViewPreferences = usePagePreferences('objectEditing');
  if (!isInViewPreferences('plainObjectEditor')) {
    return <></>;
  }

  return (
    <Panel
      title={t('PlainObjectEditorForm.AdvancedOptions')}
      additionalContainerClasses={twMerge('py-5 px-4', additionalClasses)}
      additionalTitleClasses="text-lg"
      additionalChildrenClasses={'pt-2'}
      {...getTestProps(testId, '', 'testId')}
    >
      <PlainObjectEditorForm
        {...props}
        {...getTestProps(testId, 'form', 'testId')}
      />
    </Panel>
  );
};

export default PlainObjectEditor;
